import { useCallback } from 'react'
import { useLocale } from '../../i18n/context'
import { refreshWhen } from '../../utils/textFlow'

/** «сегодня в 07:00» / «завтра в 07:00» / «5 ноября в 07:00», from the server's refresh time. */
export function useRefreshWhen(): (iso: string) => string {
  const { tr, locale } = useLocale()
  const b = tr.textFlow.save.budget
  return useCallback(
    (iso: string) => {
      const { daysAway, time } = refreshWhen(iso)
      if (daysAway <= 0) return b.today(time)
      if (daysAway === 1) return b.tomorrow(time)
      const date = new Intl.DateTimeFormat(locale, { day: 'numeric', month: 'long' })
        .format(new Date(Date.now() + daysAway * 86_400_000))
      return b.later(date, time)
    },
    [b, locale],
  )
}
